var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useState } from 'react';
import Frame from 'react-frame-component';
import { propChildren, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
import ResizeDetectorComponent from '../ResizeDetector/ResizeDetectorComponent';
/**
 * 子要素をiframeでカプセル化するためのラッパーコンポーネント
 * （外部スクリプトタグの動的実行によるグローバル汚染を回避したい時に使用してください）
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const IframeComponent = (props) => {
    const { children, className, head, onResize: parentOnResize, style } = props, otherProps = __rest(props
    // 幅を動的に制御するための値
    , ["children", "className", "head", "onResize", "style"]);
    // 幅を動的に制御するための値
    const [size, setSize] = useState({ height: 0, width: 0 });
    /**
     * iframe内部の要素の高さに合わせて調整するためのイベント
     * @type {(function(): void)|*}
     */
    const onResize = useCallback((width, height) => {
        // 内部の要素の幅を取得
        setSize({ height, width });
        // 親から渡されたイベントにも幅を返しておく
        parentOnResize(width, height);
    }, [parentOnResize]);
    return (_jsx(Frame, Object.assign({ className: clsx('ui-iframe', className), head: head, style: Object.assign(Object.assign({}, size), style) }, otherProps, { children: _jsx(ResizeDetectorComponent, Object.assign({ onResize: onResize }, { children: children })) })));
};
IframeComponent.propTypes = {
    children: propChildren(),
    className: propStr(),
    head: propChildren(),
    initialContent: propStr(),
    onResize: propFunc(),
    style: propShape(),
};
IframeComponent.defaultProps = {
    children: null,
    className: '',
    head: undefined,
    initialContent: '<!DOCTYPE html><html lang="ja"><head><title></title></head><body style="padding: 0; margin: 0;"><div /></body></html>',
    onResize: () => { },
    style: {},
};
export default IframeComponent;
